import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import './FeatureTable.css'; // Create this CSS file

const FeatureTable = () => {
  const features = [
    {
      name: 'AI-Powered Learning Modules',
      pd1: true,
      ba: true,
      lwc: true
    },
    {
      name: 'Welcome Offer',
      pd1: '₹5,000 Discount',
      ba: '₹5,000 Discount',
      lwc: '₹5,000 Discount'
    },
    {
      name: 'Naukri Profile Enhancement',
      pd1: true,
      ba: true,
      lwc: true
    },
    {
      name: 'Resume Building Support',
      pd1: true,
      ba: true,
      lwc: true
    },
    {
      name: 'LinkedIn Branding',
      pd1: true,
      ba: true,
      lwc: false
    },
    {
      name: 'Free Portfolio Website',
      pd1: true,
      ba: true,
      lwc: false
    },
    {
      name: 'Weekly Assessments & Tests',
      pd1: true,
      ba: true,
      lwc: true
    },
    {
      name: 'Mock Interviews',
      pd1: true,
      ba: true,
      lwc: true
    },
    {
      name: 'No Code / Low Code / Code Training',
      pd1: true,
      ba: true,
      lwc: true
    },
    {
      name: 'Comprehensive Training',
      pd1: '3 Months + 1 Month Projects',
      ba: '3 Months + 1 Month Projects',
      lwc: '45 Days Intensive'
    },
    {
      name: '100% Job Placement Assistance',
      pd1: 'Guaranteed*',
      ba: 'Guaranteed*',
      lwc: 'Based On Performance*'
    }
  ];

  return (
    <div className="feature-table-container">
      {/* Desktop Table */}
      <div className="desktop-table">
        <table className="feature-table">
          <thead>
            <tr>
              <th className="feature-name">Feature / Course</th>
              <th>PD1 (Platform Developer 1)</th>
              <th>BA (Business Analyst)</th>
              <th>LWC (Lightning Web Components)</th>
            </tr>
          </thead>
          <tbody>
            {features.map((feature, index) => (
              <tr key={index}>
                <td className="feature-name">{feature.name}</td>
                <td>
                  {typeof feature.pd1 === 'boolean' ? (
                    feature.pd1 ? (
                      <FontAwesomeIcon icon={faCheck} className="tick" />
                    ) : (
                      'No'
                    )
                  ) : (
                    feature.pd1
                  )}
                </td>
                <td>
                  {typeof feature.ba === 'boolean' ? (
                    feature.ba ? (
                      <FontAwesomeIcon icon={faCheck} className="tick" />
                    ) : (
                      'No'
                    )
                  ) : (
                    feature.ba
                  )}
                </td>
                <td>
                  {typeof feature.lwc === 'boolean' ? (
                    feature.lwc ? (
                      <FontAwesomeIcon icon={faCheck} className="tick" />
                    ) : (
                      'No'
                    )
                  ) : (
                    feature.lwc
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}
      <div className="mobile-cards">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            <div className="feature-title">{feature.name}</div>
            <div className="feature-options">
              <div className="option">
                <div className="option-title">PD1</div>
                <div className="option-value">
                  {typeof feature.pd1 === 'boolean' ? (
                    feature.pd1 ? (
                      <FontAwesomeIcon icon={faCheck} className="tick" />
                    ) : (
                      'No'
                    )
                  ) : (
                    feature.pd1
                  )}
                </div>
              </div>
              <div className="option">
                <div className="option-title">BA</div>
                <div className="option-value">
                  {typeof feature.ba === 'boolean' ? (
                    feature.ba ? (
                      <FontAwesomeIcon icon={faCheck} className="tick" />
                    ) : (
                      'No'
                    )
                  ) : (
                    feature.ba
                  )}
                </div>
              </div>
              <div className="option">
                <div className="option-title">LWC</div>
                <div className="option-value">
                  {typeof feature.lwc === 'boolean' ? (
                    feature.lwc ? (
                      <FontAwesomeIcon icon={faCheck} className="tick" />
                    ) : (
                      'No'
                    )
                  ) : (
                    feature.lwc
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureTable;